<template>
  <span>
    <div
      id="message-register"
      class="boss-layout-block-large"
    >
      <template v-if="isWithdraw">
        <span
          class="boss-annotation-text font-size-1-1em text-center"
          data-test="withdraw"
        >
          <div>
            応募後に退会したため、メッセージ送信ができません。
          </div>
          <div>
            レジュメ内のご連絡先に、直接ご連絡ください。
          </div>
        </span>
      </template>
      <template v-else>
        <accordion
          ref="register"
          :is-open="false"
        >
          <template #head>メッセージ作成</template>
          <template #body>
            <seminar-entry-message-register
              :entry-ids="[entryId]"
              :body="message.body"
              :subject="message.subject"
              @registered="registered"
            />
          </template>
        </accordion>
      </template>
    </div>
    <div class="boss-layout-block-large">
      <seminar-entry-message-history
        ref="seminarEntryMessageHistory"
        :entry-id="entryId"
        @set-body-and-subject="setBodyAndSubject"
      />
    </div>
  </span>
</template>

<script>
import SeminarEntryMessageRegister from '@/components/organisms/SeminarEntryMessageRegister'
import Accordion from '@/components/atoms/Accordion'
import SeminarEntryMessageHistory from '@/components/organisms/SeminarEntryMessageHistory'

export default {
  components: {
    Accordion,
    SeminarEntryMessageRegister,
    SeminarEntryMessageHistory
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      message: {
        body: '',
        subject: ''
      }
    }
  },
  computed: {},
  methods: {
    setBodyAndSubject (data) {
      this.$set(this.message, 'body', '')
      this.$set(this.message, 'subject', '')
      this.$nextTick(() => {
        this.$set(this.message, 'body', data.body)
        this.$set(this.message, 'subject', data.subject)
        this.$refs.register.status.isOpen = true
      })
    },
    registered () {
      this.$refs.register.toggle()
      this.$refs.seminarEntryMessageHistory.fetchAllMessage()
    }
  }
}
</script>
